module.exports = __webpack_public_path__ + "media/toolkits/exclamation-triangle-light-6f4bc395.svg";